import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchVue = _resolveComponent("SearchVue")!
  const _component_Map = _resolveComponent("Map")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SearchVue),
    _createVNode(_component_Map)
  ], 64))
}